import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";

import "./Historico.css";
import "./BaseLayout.css";


export default function HistoricoUpdates() {
  const [lista, setLista] = useState([]);

  const carregar = async () => {
    const snap = await getDocs(collection(db, "updates_historico"));
    let dados = snap.docs.map((d) => {
      const item = d.data();

      // === Tratamento seguro da data ===
      let data = item.dataEnvio;
      if (data?.toDate) {
        data = data.toDate(); // Firestore Timestamp
      }

      return {
        id: d.id,
        titulo: item.titulo || "(Sem título)",
        conteudo: item.conteudo || "(Sem conteúdo)",
        dataEnvio: data || null,
      };
    });

    // === Ordenar por data decrescente ===
    dados.sort((a, b) => (b.dataEnvio || 0) - (a.dataEnvio || 0));

    setLista(dados);
  };

  const deletarItem = async (id) => {
    if (!window.confirm("Apagar este update?")) return;

    await deleteDoc(doc(db, "updates_historico", id));
    carregar();
  };

  useEffect(() => {
    carregar();
  }, []);

  return (
    <div className="page-wrapper">
      <Sidebar />
      <div className="page-content">
        <Topbar />

        <div className="historico-container">
          <h2>📝 Histórico de Updates</h2>

          <table className="historico-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Conteúdo</th>
                <th>Data</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {lista.length === 0 && (
                <tr>
                  <td colSpan="4">Nenhum update enviado.</td>
                </tr>
              )}

              {lista.map((item) => (
                <tr key={item.id}>
                  <td>{item.titulo}</td>
                  <td>{item.conteudo}</td>

                  <td>
                    {item.dataEnvio
                      ? item.dataEnvio.toLocaleString()
                      : "Sem data"}
                  </td>

                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => deletarItem(item.id)}
                    >
                      Apagar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
